import { useEffect, useState } from 'react';
import type { FormPermissionsResults } from '../@types/form-permissions';
import { useFormPermissionsQuery } from '../redux/services/api';

/**
 * A hook that provides form permissions for logged-in user
 * @param {number} formId
 * @returns {{isLoading: boolean, formPermissions: FormPermissionsResults | undefined}}
 */
const useFormPermissions = (formId?: number) => {
  const [formPermissions, setFormPermissions] = useState<FormPermissionsResults>();

  const {
    data: formPermissionsResponse,
    isFetching: isFormFetching,
    isError: isFormPermissionsError,
  } = useFormPermissionsQuery(formId ?? 0, {
    skip: formId === undefined || formId === 0,
  });

  // Clear stale permissions when formId changes so callers never see
  // permissions from a previously-viewed form during the transition.
  useEffect(() => {
    setFormPermissions(undefined);
  }, [formId]);

  useEffect(() => {
    if (formPermissionsResponse && !isFormFetching) {
      setFormPermissions(formPermissionsResponse);
    }
  }, [formPermissionsResponse, isFormFetching]);

  return {
    formPermissions,
    isLoading: isFormFetching,
    isError: isFormPermissionsError,
  };
};

export default useFormPermissions;
